import { PlusOutlined } from '@ant-design/icons';
import type { MouseEvent } from 'react';
import { Button } from 'antd';

type Props = {
  expanded: boolean;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  ariaLabel: string;
};

export function SlaTableExpandButton({ expanded, onClick, ariaLabel }: Props) {
  return (
    <Button
      type="default"
      shape="circle"
      size="small"
      icon={<PlusOutlined />}
      className={`sla-table-expand-btn${expanded ? ' sla-table-expand-btn--open' : ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-expanded={expanded}
    />
  );
}
